import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";
import { authFetch } from "../utils/authFetch";
import { Browser } from "@capacitor/browser";
import { App } from "@capacitor/app";

const API_URL = process.env.REACT_APP_API_URL || "";

const money = (v) => `€ ${Number(v || 0).toFixed(2)}`;

const formatDateIT = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default function AppWalletPage() {
  const nav = useNavigate();
  const token = localStorage.getItem("access") || "";
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [rechargeAmount, setRechargeAmount] = useState(20);
  const [recharging, setRecharging] = useState(false);

  const load = async () => {
    setLoading(true);
    setErr("");

    if (!localStorage.getItem("access")) {
      setWallet(null);
      setLoading(false);
      return;
    }

    try {
      const res = await authFetch(`${API_URL}/api/app/wallet/`);

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || "Errore caricamento wallet");

      setWallet(data);
    } catch (e) {
      setErr(e.message || "Errore");
      setWallet(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const confirmStripeRecharge = async () => {
      const params = new URLSearchParams(window.location.search);
      const stripeStatus = params.get("stripe");
      const sessionId = params.get("session_id");

      if (stripeStatus !== "success" || !sessionId) {
        load();
        return;
      }

      setLoading(true);
      setErr("");

      try {
        const res = await authFetch(`${API_URL}/api/app/wallet/stripe/confirm-recharge/`, {
          method: "POST",
          json: { session_id: sessionId },
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.detail || "Errore conferma ricarica Stripe.");

        window.history.replaceState({}, "", "/app/wallet");
        await load();
      } catch (e) {
        setErr(e.message || "Errore durante la conferma della ricarica.");
        setLoading(false);
      }
    };

    confirmStripeRecharge();
  }, []);


  useEffect(() => {
    let listener;

    const setupStripeReturnListener = async () => {
      listener = await App.addListener("appUrlOpen", async ({ url }) => {
        if (!url || !url.startsWith("dallozioroby://stripe-wallet")) return;

        const sessionId = sessionStorage.getItem("dzr_stripe_wallet_session_id");

        try {
          await Browser.close();
        } catch (_) {}

        if (!sessionId) {
          setRecharging(false);
          await load();
          return;
        }

        setLoading(true);
        setErr("");

        try {
          const res = await authFetch(`${API_URL}/api/app/wallet/stripe/confirm-recharge/`, {
            method: "POST",
            json: { session_id: sessionId },
          });

          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data?.detail || "Errore conferma ricarica Stripe.");

          sessionStorage.removeItem("dzr_stripe_wallet_session_id");
          await load();
        } catch (e) {
          setErr(e.message || "Errore durante la conferma della ricarica.");
          setLoading(false);
        } finally {
          setRecharging(false);
        }
      });
    };

    setupStripeReturnListener();

    return () => {
      if (listener) listener.remove();
    };
  }, []);

  const startStripeRecharge = async () => {
    setErr("");

    const amount = Number(rechargeAmount || 0);
    if (!amount || amount < 1) {
      setErr("Inserisci un importo valido per la ricarica.");
      return;
    }

    setRecharging(true);
    try {
      const res = await authFetch(`${API_URL}/api/app/wallet/stripe/recharge-session/`, {
        method: "POST",
        json: { amount },
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.detail || "Errore creazione pagamento Stripe.");
      if (!data?.url) throw new Error("URL pagamento Stripe mancante.");

      sessionStorage.setItem("dzr_stripe_wallet_session_id", data.session_id || "");
      await Browser.open({ url: data.url });
    } catch (e) {
      setErr(e.message || "Errore durante la ricarica online.");
      setRecharging(false);
    }
  };
  const movements = wallet?.movements || [];

  return (
    <div className="container py-4" style={{ maxWidth: 760 }}>
      <TornaAlMenu to="/" />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="m-0 fw-bold">💳 Wallet Dallo Zio Roby</h2>
        <button className="btn btn-outline-dark rounded-pill px-3" onClick={load}>
          🔄 Aggiorna
        </button>
      </div>

      {loading && <p className="text-muted">Caricamento…</p>}

      {!loading && err && (
        <div className="alert alert-danger">{err}</div>
      )}

      {!loading && !token && (
        <div className="card shadow-lg border-0 rounded-5 mb-3 overflow-hidden">
          <div className="card-body p-4 text-center">
            <div className="small text-uppercase text-muted mb-2">Wallet Dallo Zio Roby</div>
            <div className="display-4 fw-bold mb-3">€ 0,00</div>
            <p className="text-muted mb-4">
              Accedi o registrati per utilizzare il Wallet, visualizzare il tuo credito e fare una ricarica.
            </p>
            <button
              type="button"
              className="btn btn-success rounded-pill px-4 py-2 fw-bold"
              onClick={() => nav("/app/login", { state: { returnTo: "/app/wallet" } })}
            >
              Accedi o registrati
            </button>
          </div>
        </div>
      )}

      {!loading && !err && wallet && (
        <>
          <div className="card shadow-lg border-0 rounded-5 mb-3 overflow-hidden">
            <div className="card-body p-4" style={{ background: "linear-gradient(135deg, #5b0f1b 0%, #8b1e2d 52%, #211014 100%)", color: "#fff" }}>
              <div className="small text-uppercase" style={{ letterSpacing: 1.2, opacity: 0.78 }}>Credito disponibile</div>
              <div className="display-4 fw-bold">{money(wallet.total_balance)}</div>

              <div className="row g-3 mt-2">
                <div className="col-6">
                  <div className="rounded-4 p-3" style={{ background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.14)" }}>
                    <div className="small" style={{ opacity: 0.78 }}>Credito normale</div>
                    <div className="fw-bold">{money(wallet.normal_balance)}</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="rounded-4 p-3" style={{ background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.14)" }}>
                    <div className="small" style={{ opacity: 0.78 }}>Credito promo</div>
                    <div className="fw-bold">{money(wallet.promo_balance)}</div>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <span className={`badge ${wallet.enabled ? "bg-success" : "bg-secondary"}`}>
                  {wallet.enabled ? "Wallet attivo" : "Wallet disattivo"}
                </span>
              </div>
            </div>
          </div>

          {wallet.active_campaign && (
            <div className="alert alert-success rounded-5 border-0 shadow-sm">
              <div className="fw-bold">🎯 Promo attiva</div>
              <div>{wallet.active_campaign.name}</div>
            </div>
          )}


            <div className="card shadow-sm border-0 rounded-5 mb-3">
              <div className="card-body p-4">
                <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                  <div>
                    <div className="text-muted small">Ricarica credito</div>
                    <h4 className="mb-1 fw-bold">Ricarica Wallet</h4>
                    <div className="text-muted">
                      Scegli un importo per la prossima ricarica del wallet.
                    </div>
                  </div>

                  <div className="text-end">
                    <div className="text-muted small">Importo selezionato</div>
                    <div className="fs-3 fw-bold">{money(rechargeAmount)}</div>
                  </div>
                </div>

                <div className="d-flex flex-wrap gap-2 mt-3">
                  {[10, 20, 50, 100].map((amount) => (
                    <button
                      key={amount}
                      type="button"
                      className={`btn rounded-pill px-4 ${Number(rechargeAmount) === amount ? "btn-success" : "btn-outline-success"}`}
                      onClick={() => setRechargeAmount(amount)}
                    >
                      {money(amount)}
                    </button>
                  ))}
                </div>

                  <div className="mt-3">
                    <label className="form-label fw-semibold">Importo libero</label>
                    <div className="input-group" style={{ maxWidth: 260 }}>
                      <span className="input-group-text">€</span>
                      <input
                        type="number"
                        min="1"
                        step="1"
                        className="form-control"
                        value={rechargeAmount}
                        onChange={(e) => setRechargeAmount(e.target.value)}
                        placeholder="Es. 200"
                      />
                    </div>
                    <div className="small text-muted mt-1">
                      Puoi scegliere un taglio rapido oppure inserire un importo personalizzato.
                    </div>
                  </div>

                <div className="alert border-0 rounded-5 mt-3 mb-0" style={{ background: "#fff8f1" }}>
                  <div className="fw-semibold">Pagamento online</div>
                  <div className="small text-muted">
                    Verrai reindirizzato alla pagina sicura Stripe per completare il pagamento.
                  </div>

                  <button
                    type="button"
                    className="btn btn-success rounded-pill px-4 mt-2"
                    onClick={startStripeRecharge}
                    disabled={recharging}
                  >
                    {recharging ? "Apertura pagamento..." : "Ricarica online"}
                  </button>
                </div>
              </div>
            </div>

          <div className="card shadow-sm border-0 rounded-5">
            <div className="card-body p-4">
              <h4 className="mb-3 fw-bold">Movimenti recenti</h4>

              {movements.length === 0 ? (
                <div className="alert alert-info mb-0">Nessun movimento registrato.</div>
              ) : (
                <div className="list-group list-group-flush">
                  {movements.map((m) => (
                    <div key={m.id} className="list-group-item px-0">
                      <div className="d-flex justify-content-between gap-3">
                        <div>
                          <div className="fw-semibold">
                            {String(m?.note || "").startsWith("Consumo in negozio:")
  ? "Consumo in negozio"
  : (m.movement_label || m.movement_type)}
                          </div>
                          <div className="small text-muted">
                            {formatDateIT(m.created_at)}
                          </div>
                          {m.note && (
                            <div className="small text-muted mt-1">
  {String(m.note).startsWith("Consumo in negozio:")
    ? String(m.note).replace(/^Consumo in negozio:\s*/, "")
    : m.note}
</div>
                          )}
                        </div>

                        <div
                          className={Number(m.amount) < 0 ? "fw-bold text-danger" : "fw-bold text-success"}
                          style={{
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                            minWidth: "max-content",
                            textAlign: "right",
                          }}
                        >
                          {money(m.amount)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
